import styled from "styled-components";
import {
  FormButton,
  FormInput,
  FormItem,
  FormSelect,
} from "../../../components/Form";
import { useApp } from "../../../contexts";
import { FilterRowItem, FilterRowItemMb } from "../styles";
import { STAKE_SUB_TAB, STAKE_TX_STATUS_OPTIONS } from "./TableStake";
import { DateRangeSelect } from "../../../components/DateRangeSelect";
import { useState } from "react";
import FormButton2 from "../../../components/FormCustom2/Button";

/**
 *
 * @typedef {Object} filterParams
 * @property {moment[]} startDateRange
 * @property {moment[]} endDateRange
 * @property {number} status
 * @property {string} transactionId
 */

const ModalBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
`;

const ModalWraper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100dvw;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  z-index: 101;
`;

export const FilterStake = ({
  show,
  filterParams,
  viewType,
  isMobile,
  onUpdate,
  onReset,
  onSearch,
  onClose,
}) => {
  const { T } = useApp();
  const [startDateOption, setStartDateOption] = useState(null);
  const [endDateOption, setEndDateOption] = useState(null);

  const handleUpdate = (newParam) => {
    onUpdate({
      ...filterParams,
      ...newParam,
    });
  };

  const handleSearchMobile = () => {
    onSearch();
    onClose();
  };

  const handleReset = () => {
    onReset();
    setStartDateOption(null);
    setEndDateOption(null);
  };

  const handleStartDateSelect = (value) => {
    setStartDateOption(value.selected);
    handleUpdate({
      startDateRange: [value.fromDate, value.toDate],
    });
  };

  const handleEndDateSelect = (value) => {
    setEndDateOption(value.selected);
    handleUpdate({
      endDateRange: [value.fromDate, value.toDate],
    });
  };

  const startDateProp = () => {
    return {
      selected: startDateOption,
      fromDate: filterParams?.startDateRange?.[0],
      toDate: filterParams?.startDateRange?.[1],
    };
  };

  const endDateProp = () => {
    return {
      selected: endDateOption,
      fromDate: filterParams?.endDateRange?.[0],
      toDate: filterParams?.endDateRange?.[1],
    };
  };

  const renderActiveBalanceDesktopFilter = () => {
    return (
      <>
        <FilterRowItem>
          <FormItem label={T("Start Date")}>
            <DateRangeSelect
              value={startDateProp()}
              onChange={handleStartDateSelect}
            />
          </FormItem>
        </FilterRowItem>
        <FilterRowItem>
          <FormItem label={T("End Date")}>
            <DateRangeSelect
              value={endDateProp()}
              onChange={handleEndDateSelect}
            />
          </FormItem>
        </FilterRowItem>
        <FilterRowItem>
          <FormItem label={T("Transaction ID")}>
            <FormInput
              value={filterParams?.transactionId}
              onChange={(e) => {
                handleUpdate({ transactionId: e.target.value });
              }}
              placeholder={T("Please enter Transaction ID")}
            />
          </FormItem>
        </FilterRowItem>
      </>
    );
  };

  const renderStakeHistoryDesktopFilter = () => {
    return (
      <>
        <FilterRowItem>
          <FormItem label={T("Time")}>
            <DateRangeSelect
              value={startDateProp()}
              onChange={handleStartDateSelect}
            />
          </FormItem>
        </FilterRowItem>
        <FilterRowItem>
          <FormItem label={T("Status")}>
            <FormSelect
              value={filterParams?.status}
              defaultValue={STAKE_TX_STATUS_OPTIONS[0].value}
              allowClear={false}
              onChange={(value) => {
                handleUpdate({ status: value });
              }}
            >
              {STAKE_TX_STATUS_OPTIONS.map((status) => (
                <FormSelect.Option key={status.value} value={status.value}>
                  {T(status.label)}
                </FormSelect.Option>
              ))}
            </FormSelect>
          </FormItem>
        </FilterRowItem>
        <FilterRowItem>
          <FormItem label={T("Transaction ID")}>
            <FormInput
              value={filterParams?.transactionId}
              onBlur={(e) => {
                handleUpdate({ transactionId: e.target.value });
              }}
              placeholder={T("Please enter Transaction ID")}
            />
          </FormItem>
        </FilterRowItem>
      </>
    );
  };

  const renderDesktopFilter = () => {
    return (
      <>
        {show && (
          <>
            <div className="flex justify-start gap-2">
              {viewType === STAKE_SUB_TAB.ACTIVE &&
                renderActiveBalanceDesktopFilter()}
              {viewType === STAKE_SUB_TAB.HISTORY &&
                renderStakeHistoryDesktopFilter()}
              <div className="w-[120px] flex"></div>
            </div>

            <div className="flex justify-end">
              <div className="w-[400px] flex gap-2">
                <FormButton2
                  style={{ width: "50%" }}
                  className="black2"
                  height={52}
                  width={144}
                  onClick={handleReset}
                >
                  {T("Reset")}
                </FormButton2>
                <FormButton
                  onClick={() => onSearch()}
                  className="black2"
                  style={{ width: "50%" }}
                >
                  {T("Search")}
                </FormButton>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  const renderActiveBalanceMobileFilter = () => {
    return (
      <>
        <FilterRowItemMb>
          <FormItem label={T("Start Date")}>
            <DateRangeSelect
              value={startDateProp()}
              onChange={handleStartDateSelect}
            />
          </FormItem>
        </FilterRowItemMb>
        <FilterRowItemMb>
          <FormItem label={T("End Date")}>
            <DateRangeSelect
              value={endDateProp()}
              onChange={handleEndDateSelect}
            />
          </FormItem>
        </FilterRowItemMb>
        <FilterRowItemMb>
          <FormItem label={T("Transaction ID")}>
            <FormInput
              value={filterParams?.transactionId}
              onBlur={(e) => {
                handleUpdate({ transactionId: e.target.value });
              }}
              placeholder={T("Please enter Transaction ID")}
            />
          </FormItem>
        </FilterRowItemMb>
      </>
    );
  };

  const renderStakeHistoryMobileFilter = () => {
    return (
      <>
        <FilterRowItemMb>
          <FormItem label={T("Time")}>
            <DateRangeSelect
              value={startDateProp()}
              onChange={handleStartDateSelect}
            />
          </FormItem>
        </FilterRowItemMb>
        <FilterRowItemMb>
          <FormItem label={T("Status")}>
            <FormSelect
              value={filterParams?.status}
              allowClear={false}
              onChange={(value) => {
                handleUpdate({ status: value });
              }}
            >
              {STAKE_TX_STATUS_OPTIONS.map((status) => (
                <FormSelect.Option key={status.value} value={status.value}>
                  {T(status.label)}
                </FormSelect.Option>
              ))}
            </FormSelect>
          </FormItem>
        </FilterRowItemMb>
        <FilterRowItemMb>
          <FormItem label={T("Transaction ID")}>
            <FormInput
              value={filterParams?.transactionId}
              onChange={(e) => {
                handleUpdate({ transactionId: e.target.value });
              }}
              placeholder={T("Please enter Transaction ID")}
            />
          </FormItem>
        </FilterRowItemMb>
      </>
    );
  };

  const renderMobileFilter = () => {
    return (
      <>
        {show && (
          <>
            <ModalBg onClick={() => onClose()}></ModalBg>
            <ModalWraper>
              <div className="flex flex-col w-full h-full p-6">
                <div className="flex w-full justify-center font-[700] text-[24px]/[36px] mt-[15px]">
                  {T("Filter")}
                </div>
                <div className="py-[10px]">
                  {viewType === STAKE_SUB_TAB.ACTIVE &&
                    renderActiveBalanceMobileFilter()}
                  {viewType === STAKE_SUB_TAB.HISTORY &&
                    renderStakeHistoryMobileFilter()}

                  <div className="flex justify-center items-center gap-4 mt-[20px]">
                    <div
                      className="flex justify-center items-center relative top-1 px-[14px]
                                bg-white gap-[8px] rounded-[10px] h-[52px] w-[40%] cursor-pointer"
                      onClick={handleReset}
                    >
                      {T("Clear")}
                    </div>
                    <div
                      className="flex justify-center items-center relative top-1 px-[14px]
                                bg-black text-white gap-[8px] rounded-[10px] h-[52px] w-[40%] cursor-pointer"
                      onClick={handleSearchMobile}
                    >
                      {T("Search")}
                    </div>
                  </div>
                </div>
              </div>
            </ModalWraper>
          </>
        )}
      </>
    );
  };

  if (isMobile) {
    return renderMobileFilter();
  } else {
    return renderDesktopFilter();
  }
};
